import * as Yup from "yup";

const uploadChangeDocumentsValidation = (documentData) => {
  return Yup.object().shape({
    documentsAreSigned: Yup.string().required(
      "Please select whether the documents are signed or not"
    ),
    consentResolutionType: Yup.string().when("documentsAreSigned", {
      is: "false",
      then: Yup.string().required("Please select a resolution type"),
      otherwise: Yup.string().notRequired(),
    }),
    fileUploads: Yup.mixed().when(
      ["documentsAreSigned", "consentResolutionType"],
      {
        is: (documentsAreSigned, consentResolutionType) => {
          if (documentsAreSigned === "true") {
            return true; // If documents are signed, file upload is always required
          } else if (consentResolutionType !== undefined) {
            // If consent resolution type is selected, check if file upload is required based on documentData
            const relevantData = documentData.find(
              (data) =>
                data.documentsAreSigned === "false" &&
                data.selectResolutionType === consentResolutionType
            );
            return relevantData ? relevantData.fileMustUpload : false;
          } else {
            return false; // If no resolution type is selected, file upload is not required
          }
        },
        then: Yup.mixed().required("Please upload the document"),
        otherwise: Yup.mixed().notRequired(),
      }
    ),
  });
};

export default uploadChangeDocumentsValidation;
